import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { Modal, HiddenSpan, ExpandableItem } from 'components'
import * as Types from 'types'
import { getFormWideErrorMessage } from 'utils'
import { AddPartnerForm, AddPendingPartnerForm } from '../forms'

const propTypes = {
  onClose: PropTypes.func.isRequired,
  partnershipOptions: PropTypes.arrayOf(Types.searchSuggestion),
  onSubmit: PropTypes.func.isRequired,
  onSubmitSuccess: PropTypes.func.isRequired,
  existingPartnerships: PropTypes.arrayOf(Types.schoolPartnershipType),
}

const defaultProps = {
  partnershipOptions: [],
  existingPartnerships: [],
}

function AddPartnershipModal({
  onClose,
  partnershipOptions,
  onSubmit,
  onSubmitSuccess,
  existingPartnerships,
}) {
  const [formWideError, setFormWideError] = useState(null)
  const [submitFailCount, setSubmitFailCount] = useState(0)
  return (
    <Modal onClose={onClose}>
      <h2>Add New Partnership</h2>
      <div className="modal-content">
        <div role="alert" aria-atomic>
          {formWideError && (
            <p className="full-error-message">
              {/* The hidden count will force screen readers to announce
               the error again even when it's exactly the same */}
              {formWideError} <HiddenSpan>{submitFailCount}</HiddenSpan>
            </p>
          )}
        </div>
        <AddPartnerForm
          partnershipOptions={partnershipOptions}
          onSubmit={({ selectedOption }, ...rest) => {
            let submitData = {}
            if (selectedOption.type === 'teaching_artist_inventory') {
              submitData = {
                teachingArtistId: selectedOption.id,
                artistName: selectedOption.name,
                organizationId: null,
                organizationName: null,
              }
            } else {
              submitData = {
                organizationId: selectedOption.id,
                organizationName: selectedOption.name,
                teachingArtistId: null,
                artistName: null,
              }
            }
            return onSubmit(
              {
                ...submitData,
              },
              false,
              ...rest
            )
          }}
          onSubmitFail={(errors, _, submitError) => {
            setSubmitFailCount((sfc) => sfc + 1)
            const msg = getFormWideErrorMessage(errors, submitError)
            setFormWideError(msg)
          }}
          onSubmitSuccess={(params, ...rest) =>
            onSubmitSuccess(params, false, ...rest)
          }
          existingPartnerships={existingPartnerships}
        />
        <br />
        <div className="expandable-section pending-partner-expander">
          <ExpandableItem
            headerTitle={`Don't see the Partner you want to add? Add a New Partner`}
            expandTriggerable={true}
          >
            <div className="">
              <p id="pending-partner-label">
                If you cannot find the partner you wish to add in the list of
                known partners above, then you may enter the partner's
                information below instead. This will create a "pending"
                partnership and will alert the administrator to review the
                information you have provided.
              </p>
              <p>
                Please try other variations of the name (e.g. MADD Rhythms as
                M.A.D.D. Rhythms) before submitting a pending partnership.
              </p>
              <AddPendingPartnerForm
                onSubmit={(params, ...rest) => onSubmit(params, true, ...rest)}
                onSubmitSuccess={(params, ...rest) =>
                  onSubmitSuccess(params, true, ...rest)
                }
                onSubmitFail={(errors, _, submitError) => {
                  setSubmitFailCount((sfc) => sfc + 1)
                  const msg = getFormWideErrorMessage(errors, submitError)
                  setFormWideError(msg)
                }}
                ariaLabelledby="pending-partner-label"
              />
            </div>
          </ExpandableItem>
        </div>
      </div>
    </Modal>
  )
}

AddPartnershipModal.propTypes = propTypes
AddPartnershipModal.defaultProps = defaultProps

export default AddPartnershipModal
